// Ensure global Teleport targets exist on <body> before any component tries to
// teleport into them. Putting them in app.vue races against page-level dialogs
// whose mount path can resolve before the sibling target divs commit to the DOM.
export default defineNuxtPlugin(() => {
  const ids = ['dialog-container', 'modal-container']

  for (const id of ids) {
    if (!document.getElementById(id)) {
      const el = document.createElement('div')
      el.id = id
      document.body.appendChild(el)
    }
  }
})
